// extracted by mini-css-extract-plugin
export default {"confirmButtonContainer":"style_confirmButtonContainer__klCf4","confirmButton":"style_confirmButton__ONLdI","tyreSelect":"style_tyreSelect__OM+LN"};